import type { DocumentContext } from '@voll-intelligence/trip-document';
import { currentLocale, t } from './i18n.js';

/** O contexto do web-chat para os builders do trip-document: o `t` tipado do
 *  i18next por baixo da assinatura frouxa do pacote, e o locale ativo. Função,
 *  não constante — o locale muda em runtime (LocaleRoot remonta a árvore). */
export function documentCtx(): DocumentContext {
  return {
    t: (key, vars) => t(key, vars),
    locale: currentLocale(),
  };
}
